import { Injectable } from "@nestjs/common";
import { VisitorDto } from "./dto/security.dto";
import { VisitorEntry } from "./entity/security.entity";

@Injectable()
export class VisitorAdapter{
    public convertVisitorDtoToEntity(visitorDTO: VisitorDto): VisitorEntry{
        const visitorEntity = new VisitorEntry();
        visitorEntity.id= visitorDTO.id;
        visitorEntity.requestId= visitorDTO.requestId;
        visitorEntity.visitorName = visitorDTO.visitorName;
        visitorEntity.visitorCard = visitorDTO.visitorCard;
        // visitorEntity.checkIn = visitorDTO.checkIn;
        visitorEntity.checkOut = visitorDTO.checkOut; 
        visitorEntity.isActive= visitorDTO.isActive === undefined ? true : visitorDTO.isActive;
        return visitorEntity;
    }

    public convertVisitorEntityToDto(visitorObj: VisitorEntry): VisitorDto{
        const visitorDTO = new VisitorDto;
        visitorDTO.id= visitorObj.id;
        visitorDTO.requestId= visitorObj.requestId;
        visitorDTO.visitorName = visitorObj.visitorName;
        visitorDTO.visitorCard = visitorObj.visitorCard;
        visitorDTO.checkIn = visitorObj.checkIn;
        visitorDTO.checkOut = visitorObj.checkOut; 
        return visitorDTO;
    }
}